import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
// @mui
import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { FormProvider, RHFSelect, RHFTextField } from '../../../components/hook-form';

// import { getBranchManagers } from '../../users/store/userActions';
import { getAuditBranches } from '../../branches/store/branchActions';
import { getAuditDepartments } from '../../departments/store/departmentActions';
import { transferAsset } from '../store/assetActions';

const ASSET_CONDITIONS = [
  {
    id: 1,
    label: 'New',
    value: 'new',
  },
  {
    id: 2,
    label: 'Used',
    value: 'used',
  },
];
NewTransfer.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  assetIds: PropTypes.array,
};

export default function NewTransfer({ open, handleClose, assetIds }) {
  const dispatch = useDispatch();
  // const { auditUsers } = useSelector((state) => state.userReducer);
  const { isLoading, isSuccess } = useSelector((state) => state.assetReducer);
  const { auditBranches } = useSelector((state) => state.branchReducer);
  const { auditDepartments } = useSelector((state) => state.departmentReducer);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  useEffect(() => {
    if (hasSubmitted && isSuccess) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, hasSubmitted]);

  const NewTransferSchema = Yup.object().shape({});

  const defaultValues = {
    assetIds,
    locationId: '',
    departmentId: '',
    custodianName: '',
    condition: '',
    description: '',
  };

  const methods = useForm({
    resolver: yupResolver(NewTransferSchema),
    defaultValues,
  });

  const {
    // reset,
    watch,
    // control,
    // setValue,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const values = watch();

  console.log('VALUES:', values);

  const onSubmit = async (data) => {
    const payload = {
      location_id: data.locationId,
      department_id: data.departmentId,
      custodian_name: data.custodianName,
      asset_ids: assetIds,
      condition: data.condition,
      description: data.description,
    };
    setHasSubmitted(true);
    dispatch(transferAsset(payload));
  };
  useEffect(() => {
    // dispatch(getAuditUsers({}));
    dispatch(getAuditBranches({}));
    dispatch(getAuditDepartments());
  }, [dispatch]);

  return (
    <Dialog
      maxWidth="md"
      open={open}
      fullWidth
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Asset transfer</DialogTitle>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <DialogContent dividers>
          <Stack spacing={2}>
            <RHFSelect
              fullWidth
              name="locationId"
              label="Select Location"
              InputLabelProps={{ shrink: true }}
              SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
            >
              {auditBranches?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </RHFSelect>
            <RHFSelect
              fullWidth
              name="departmentId"
              label="Select Department"
              InputLabelProps={{ shrink: true }}
              SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {auditDepartments?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </RHFSelect>
            <RHFTextField name="custodianName" label="Custodian Name" />
            <RHFSelect
              fullWidth
              name="condition"
              label="Condition at Transfer"
              InputLabelProps={{ shrink: true }}
              SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
            >
              {ASSET_CONDITIONS?.map((option) => (
                <MenuItem key={option.id} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </RHFSelect>
            <RHFTextField name="description" label="Description" />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="contained" color="error" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton
            loading={isLoading}
            disabled={isSubmitting}
            type="submit"
            size="small"
            variant="contained"
            startIcon={<CheckCircleOutlineOutlinedIcon />}
          >
            Transfer
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
